import { SxProps, Theme, useTheme } from "@mui/material/styles";
import { useContext } from "react";
import SectionPageContext from "../../SectionPageContext";
import React from "react";
import { BNBox } from "@bn-monorepo/js-packages";
import styleToObject from "style-to-object";

interface Props {
  className?: string;
  sectionContainerStylesOverride?: string;
  gridOrder?: number;
  sxTextSectionContainer?: SxProps<Theme>;
  children?: React.ReactNode;
}

const SectionWrapperText: React.FC<Props> = (props) => {
  const { className, sectionContainerStylesOverride, gridOrder, sxTextSectionContainer } = props;

  const { textSectionContainerMaxWidthOverride, textSectionContainerMaxWidthOverrideMobile, isArticle } =
    useContext(SectionPageContext);
  const theme = useTheme();

  const parsedStylesOverrideObject = sectionContainerStylesOverride
    ? styleToObject(sectionContainerStylesOverride)
    : undefined;

  let textSectionContainerSx: SxProps<Theme> = [
    {
      width: "100%",
      padding: isArticle ? undefined : { xs: 2, sm: 6 },
    },
    // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
    ...(Array.isArray(sxTextSectionContainer) ? sxTextSectionContainer : [sxTextSectionContainer]),
  ];

  if (textSectionContainerMaxWidthOverride) {
    textSectionContainerSx = [
      ...textSectionContainerSx,
      {
        [theme.breakpoints.up("md")]: {
          maxWidth: textSectionContainerMaxWidthOverride,
        },
      },
    ];
  }

  if (textSectionContainerMaxWidthOverrideMobile) {
    textSectionContainerSx = [
      ...textSectionContainerSx,
      {
        [theme.breakpoints.down("md")]: {
          maxWidth: textSectionContainerMaxWidthOverrideMobile,
        },
      },
    ];
  }

  return (
    <BNBox
      component={"section"}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        fontSize: "1.6rem",
        [theme.breakpoints.up("md")]: {
          order: gridOrder,
        },
      }}
      style={{ ...parsedStylesOverrideObject }}
    >
      <BNBox className={className} sx={textSectionContainerSx}>
        {props.children}
      </BNBox>
    </BNBox>
  );
};

export default SectionWrapperText;
